// extracted by mini-css-extract-plugin
export default {"popover":"Info_popover__0jDb6","title":"Info_title__9DhVR","text":"Info_text__8DW+J","link":"Info_link__jZUB0"};